import type { UserInformation } from '@efficiently/client-api-auth';

export function toUserDisplayName(userInfo: UserInformation | null): string {
	const contact = userInfo?.contact;

	return `${contact?.firstName ?? ''} ${contact?.lastName ?? ''}`.trim();
}
